import { DuffelCardFormProps } from "./types";

export function getIFrameOriginForEnvironment(
  tokenProxyEnvironment: DuffelCardFormProps["tokenProxyEnvironment"],
): string {
  let origin = "https://api.duffel.cards";
  if (tokenProxyEnvironment === "staging") {
    origin = "https://api.staging.duffel.cards";
  } else if (tokenProxyEnvironment === "development") {
    origin = "https://localhost:8000";
  }

  return origin;
}
;
import "/Users/igordepaula/.yarn/berry/cache/@sentry-bundler-plugin-core-npm-0.7.2-054e3436fd-10c0.zip/node_modules/@sentry/bundler-plugin-core/sentry-release-injection-file.js";